import React from "react";

// Orion Road wordmark with constellation accent
// Orion's belt = 3 stars connected by thin lines, sitting above the wordmark.
export const Logo = ({ className = "", size = "md" }) => {
    const sizes = {
        sm: { wordmark: "text-[13px]", track: "tracking-[0.32em]", svg: 72 },
        md: { wordmark: "text-[22px]", track: "tracking-[0.32em]", svg: 126 },
        lg: { wordmark: "text-[34px]", track: "tracking-[0.26em]", svg: 168 },
    };
    const s = sizes[size] || sizes.md;
    return (
        <span
            data-testid="brand-logo"
            className={`group inline-flex flex-col items-start ${className}`}
            aria-label="Orion Road — Home"
        >
            <svg
                width={s.svg}
                height={s.svg * 0.28}
                viewBox="0 0 140 40"
                fill="none"
                className="mb-2 opacity-90 group-hover:opacity-100 transition-opacity"
                aria-hidden="true"
            >
                {/* Connecting lines (Orion belt + outer stars) */}
                <line x1="10" y1="28" x2="44" y2="14" stroke="rgba(226,232,240,0.45)" strokeWidth="0.6" />
                <line x1="44" y1="14" x2="70" y2="20" stroke="rgba(226,232,240,0.7)" strokeWidth="0.6" />
                <line x1="70" y1="20" x2="96" y2="14" stroke="rgba(226,232,240,0.7)" strokeWidth="0.6" />
                <line x1="96" y1="14" x2="130" y2="28" stroke="rgba(226,232,240,0.45)" strokeWidth="0.6" />
                {/* Outer stars */}
                <circle cx="10" cy="28" r="1.4" fill="#E2E8F0" opacity="0.7" />
                <circle cx="130" cy="28" r="1.4" fill="#E2E8F0" opacity="0.7" />
                {/* Orion's belt — warm accent */}
                <circle cx="44" cy="14" r="2" fill="#D4A858" />
                <circle cx="70" cy="20" r="2.4" fill="#D4A858" />
                <circle cx="96" cy="14" r="2" fill="#D4A858" />
            </svg>
            <span
                className={`font-sans ${s.wordmark} ${s.track} uppercase font-medium text-white/95 leading-none`}
            >
                Orion <span className="text-white/55">Road</span>
            </span>
        </span>
    );
};

export default Logo;
